import classnames from 'classnames';
import toolbarStyles from '../../../components/Toolbar/Toolbar.module.css';
import styles from './InsertTableSizer.module.css';
import React, { useRef, useState } from 'react';
import type { ToolbarSubmenuProps } from '../../../types/aha-editor';
import type ToolMark from '../../Formatting/tools/ToolMark';
import { ReactEditor } from 'slate-react';

const DEFAULT_ROW_INDEX = 1;
const DEFAULT_COLUMN_INDEX = 1;

const MAX_ROWS = 9;
const MAX_COLUMNS = 9;

const InsertTableSizer: React.FC<ToolbarSubmenuProps<typeof ToolMark>> = ({
  editor,
  controller,
  tool,
  isSubmenu,
}) => {
  const [rowIndex, setRowIndex] = useState(DEFAULT_ROW_INDEX);
  const [columnIndex, setColumnIndex] = useState(DEFAULT_COLUMN_INDEX);
  const menuRef = useRef<HTMLElement>();
  const rows = Array(MAX_ROWS).fill(0);
  const columns = Array(MAX_COLUMNS).fill(0);

  const insertTable = (rows: number, columns: number) => {
    menuRef.current?.removeAttribute('open');
    menuRef.current?.closest('aha-menu-content[open]')?.removeAttribute('open');
    tool.action({ editor, controller, rows, columns });
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu submenu={isSubmenu} ref={menuRef}>
      <div
        slot="control"
        className={classnames({
          [toolbarStyles.toolbarButtonDisabled]: !tool.isEnabled({
            editor,
            controller,
          }),
        })}
        aria-label={tool.ariaLabel}
      >
        <i className={classnames('fa-fw', tool.iconClass)} />
        {isSubmenu && tool.label}
      </div>
      <aha-menu-content>
        <div
          className={styles.tableSizerContainer}
          onMouseOut={() => {
            setRowIndex(DEFAULT_ROW_INDEX);
            setColumnIndex(DEFAULT_COLUMN_INDEX);
          }}
        >
          <table className={styles.tableSizer}>
            <tbody>
              {rows.map((_, y) => (
                <tr key={y}>
                  {columns.map((_, x) => (
                    <td
                      key={x}
                      onMouseEnter={() => {
                        setRowIndex(y);
                        setColumnIndex(x);
                      }}
                      onClick={() => insertTable(y + 1, x + 1)}
                      className={classnames(styles.cell, {
                        [styles.selected]: rowIndex >= y && columnIndex >= x,
                      })}
                    />
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <div className={styles.dimensions}>
            {columnIndex + 1} x {rowIndex + 1}
          </div>
        </div>
      </aha-menu-content>
    </aha-menu>
  );
};

export default InsertTableSizer;
